import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/features/auth/AuthContext";
import {
  LGoButton,
  LGoCard,
  LGoCardHeader,
  LGoCardTitle,
  LGoCardDescription,
  LGoCardContent,
} from "@/ui/branded";

export default function ConfirmEmailPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center space-y-1">
          <h1 className="font-display text-6xl font-semibold tracking-[-0.05em] text-foreground">
            LastGO<span className="text-primary">.</span>
          </h1>
          <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground">
            Partnerský portál
          </p>
        </div>

        <LGoCard variant="raised" padding="lg">
          {user ? (
            <>
              <LGoCardHeader>
                <LGoCardTitle className="text-2xl">Registrace dokončena</LGoCardTitle>
                <LGoCardDescription>
                  Váš účet je potvrzený a můžete začít spravovat svůj podnik.
                </LGoCardDescription>
              </LGoCardHeader>
              <LGoCardContent>
                <LGoButton
                  variant="primary"
                  className="w-full"
                  onClick={() => navigate("/", { replace: true })}
                >
                  Pokračovat do portálu
                </LGoButton>
              </LGoCardContent>
            </>
          ) : (
            <>
              <LGoCardHeader>
                <LGoCardTitle className="text-2xl">Odkaz už neplatí</LGoCardTitle>
                <LGoCardDescription>
                  Potvrzovací odkaz vypršel nebo už byl použit. Pokud je účet potvrzený, stačí se
                  přihlásit.
                </LGoCardDescription>
              </LGoCardHeader>
              <LGoCardContent>
                <LGoButton
                  variant="primary"
                  className="w-full"
                  onClick={() => navigate("/auth", { replace: true })}
                >
                  Přihlásit se
                </LGoButton>
              </LGoCardContent>
            </>
          )}
        </LGoCard>
      </div>
    </div>
  );
}
